/*
    © 2022 KondaSoft.com
    https://www.kondasoft.com
*/

// Ajax 'Add To Cart' (ATC) forms
window.onSubmitAtcForm = async (form, event) => {
  event.preventDefault();

  const btn = form.querySelector('button[name="add"]');
  btn.classList.add("loading");
  formData = new FormData(form);

  let cartData = {
    items: [
      {
        id: parseInt(formData.get("id")),
        qauntity: 1,
      },
    ],
  };

  const addSecondProductCheckbox = document.querySelector(
    "input[name=add_second_product]"
  );
  const secondProductId = document.querySelector(
    "input[name=second_product_id]"
  );
  const addSecondProduct =
    addSecondProductCheckbox &&
    addSecondProductCheckbox.checked &&
    secondProductId.dataset.available === "true";

  // tagging second product to main product so we can remove second product with main product
  if (addSecondProduct) {
    cartData.items[0] = {
      ...cartData.items[0],
      properties: {
        _second_product_id: secondProductId.value,
      },
    };
  }

  if (addSecondProduct) {
    let secondProductId = parseInt(formData.get("second_product_id"));

    cartData.items.push({
      id: secondProductId,
      quantity: 1,
      properties: {
        _disable_quantity_edit: true,
      },
    });
  }

  const addonProducts = document.querySelectorAll(".addon-product");

  addonProducts.forEach((addonProduct) => {
    const addAddonCheckbox = addonProduct.querySelector(
      "input[name=add_addon]"
    );
    if (addAddonCheckbox.checked) {
      let productId = parseInt(addonProduct.dataset.id);
      cartData.items.push({
        id: productId,
        quantity: 1,
      });
    }
  });

  // putting items in order
  cartData.items = cartData.items.reverse();

  await fetch("/cart/add.js", {
    method: "POST",
    body: JSON.stringify(cartData),
    headers: {
      "Content-Type": "application/json",
    },
  });

  btn.classList.remove("loading");

  if (document.querySelector("#offcanvas-cart")) {
    bootstrap.Offcanvas.getOrCreateInstance("#offcanvas-cart").show();
  }

  window.refreshCartContents();
};

window.updateAddToCartTotalPrice = () => {
  let productPrices = [];

  // main product price
  productPrices.push(parseInt(getSelectedVariantPrice()));

  // second product price if checked
  if (document.querySelector("#add_second_product:checked")) {
    let secondProductSelect = document.querySelector("#second-product");
    let secondProductPrice =
      secondProductSelect.options[secondProductSelect.selectedIndex].dataset
        .productPrice;
    productPrices.push(parseInt(secondProductPrice));
  }

  // any addon product prices that are checked
  [
    ...document.querySelectorAll(
      ".addon-product input[name=add_addon]:checked"
    ),
  ].map((element) =>
    productPrices.push(parseInt(element.dataset.productPrice))
  );

  const sum = productPrices.reduce((partialSum, a) => partialSum + a, 0);

  document.querySelector(
    "button.btn-atc"
  ).innerHTML = `ADD TO CART&nbsp;-&nbsp;${formatMoney(sum)}`;
};

const initBubbleOptions = function () {
  const bubbleOptionsList = document.querySelectorAll(".bubble-options");

  bubbleOptionsList.forEach((bubbleOptions) => {
    if (bubbleOptions) {
      const bubbleOptionsLabels = bubbleOptions.querySelectorAll("label");
      const bubbleOptionsInputs = bubbleOptions.querySelectorAll("input");

      const resetLabels = (bubbleOptionsLabels) => {
        bubbleOptionsLabels.forEach((label) => {
          if (label.classList.contains("selected")) {
            label.classList.remove("selected");
          }
        });
      };

      bubbleOptionsInputs.forEach((input) => {
        input.addEventListener("change", (e) => {
          resetLabels(bubbleOptionsLabels);

          // console.log(`e.target`, e.target);
          if (e.target.checked) {
            e.target.parentElement.classList.add("selected");
          }
        });
      });
    }
  });
};

initBubbleOptions();

/*
    This function updates the product option select element
    based on the selected value of the bubble element.
*/
function updateProductOptionSelect(input) {
  const bubbleElementValue = input.value;
  const productOptionSelectElement = document.querySelector(
    ".product-option-select select"
  );
  const optionsElements = productOptionSelectElement.querySelectorAll("option");

  if (optionsElements) {
    // setting display visible or none
    optionsElements.forEach((element) => {
      if (element.dataset.productOption1Value == bubbleElementValue) {
        element.style.display = "";
      } else {
        element.style.display = "none";
      }
    });

    // making select updates to display correct item
    for (var i = 0; i < optionsElements.length; i++) {
      if (optionsElements[i].style.display !== "none") {
        productOptionSelectElement.selectedIndex = i;
        break;
      }
    }
  }
}

// Product Options - listen for onchange events
window.onChangeProductOption = async (input) => {
  // update product color options
  if (document.querySelector(".product-color-slider") !== null) {
    setProductColorOptionAvailability();

    if (hasParentWithClass(input, "bubble-options")) {
      document
        .querySelectorAll(".product-color-slider input.product-option")[0]
        .click();
      productColorSlider.slideTo(0);
    }
  }

  // update product option select
  if (document.querySelector(".product-option-select") !== null) {
    if (hasParentWithClass(input, "bubble-options")) {
      updateProductOptionSelect(input);
    }
  }

  const productWrapper = input.closest(".product");
  const addToCartBtn = productWrapper.querySelector('[name="add"]');
  const productError = productWrapper.querySelector(".product-error");

  console.log("I do get here");

  const response = await fetch(`/products/${input.dataset.productHandle}.js`);
  const productData = await response.json();

  
  console.log(productData);

  const productOptions = [];

  productWrapper.querySelectorAll(".product-option:checked").forEach((el) => {
    productOptions.push(el.value);
  });

  const selectedVariant = productData.variants.find((variant) => {
    const productOptionsString = productOptions
      .toString()
      .replaceAll(",", " / ");
    return variant.title === productOptionsString;
  });

  console.log("----------------------------------------------");
  console.log(selectedVariant);
  console.log(selectedVariant.featured_image);

  if (selectedVariant) {
    productWrapper.querySelector('[name="id"]').value = selectedVariant.id;

    // Checks if the selected variant is available. If it is, it clears any
    // error messages and enables the add-to-cart button. If not available,
    // it displays an error message and disables the add-to-cart button.
    if (selectedVariant.available) {
      productError.innerHTML = "";
      productError.style.display = "none";
      addToCartBtn.disabled = false;
    } else {
      productError.innerHTML = "Selected product not available.";
      productError.style.display = "block";
      addToCartBtn.disabled = true;
    }

    // Updates the product price display based on whether the current
    // price is less than the compare-at price. If true, it shows the discounted
    // and original prices; otherwise, it hides the compare-at price and displays
    // only the current price.
    if (
      selectedVariant.compare_at_price &&
      selectedVariant.price < selectedVariant.compare_at_price
    ) {
      productWrapper.querySelector(".product-price-compare").style.display =
        "inline-block";
      productWrapper.querySelector(".product-price-compare s").innerHTML =
        window.formatMoney(selectedVariant.compare_at_price);
      productWrapper.querySelector(".product-price-final").innerHTML =
        window.formatMoney(selectedVariant.price);
    } else {
      productWrapper.querySelector(".product-price-compare").style.display =
        "none";
      productWrapper.querySelector(".product-price-compare s").innerHTML = "";
      productWrapper.querySelector(".product-price-final").innerHTML =
        window.formatMoney(selectedVariant.price);
    }

    // Navigates a Bootstrap carousel to the selected variant's media
    // position, adjusting for zero-based indexing, and logs any errors to the console.
    try {
      bootstrap.Carousel.getOrCreateInstance("#product-carousel")?.to(
        selectedVariant.featured_media.position - 1
      );
    } catch (error) {
      console.error(error);
    }
    
    // This code sets the "variant" query parameter to the selected
    // variant's ID and updates the browser's URL without reloading the page.
    const url = new URL(window.location);
    url.searchParams.set("variant", selectedVariant.id);
    window.history.replaceState({}, "", url);

  } else {
    productError.innerHTML = "Selected product not available.";
    productError.style.display = "block";
    addToCartBtn.disabled = true;
  }
};

window.onChangeSecondProductCheckbox = async (input) => {
  const secondProductActive = input.checked;
  const secondProductCol = document.querySelector(".second-product-options");

  if (secondProductActive) {
    if (secondProductCol.classList.contains("active") == false) {
      secondProductCol.classList.add("active");
    }
  } else {
    if (secondProductCol.classList.contains("active")) {
      secondProductCol.classList.remove("active");
    }
  }
};

// Product Options - listen for onchange events
window.onChangeSecondProductOption = async (input) => {
  const productWrapper = input.closest(".product");
  const response = await fetch(`/products/${input.dataset.productHandle}.js`);
  const productData = await response.json();

  const productOptions = [];

  productWrapper.querySelectorAll(".second-product-option").forEach((el) => {
    productOptions.push(el.value);
  });

  const selectedVariant = productData.variants.find(
    (variant) => variant.id == input.value
  );

  if (selectedVariant) {
    productWrapper.querySelector('[name="second_product_id"]').value =
      selectedVariant.id;

    if (selectedVariant.compare_at_price) {
      productWrapper.querySelector(
        ".second-product-price-compare"
      ).style.display = "inline-block";
      productWrapper.querySelector(
        ".second-product-price-compare s"
      ).innerHTML = window.formatMoney(selectedVariant.compare_at_price);
      productWrapper
        .querySelector(".second-product-price-final")
        .classList.add("text-success");
      productWrapper.querySelector(".second-product-price-final").innerHTML =
        window.formatMoney(selectedVariant.price);
    } else {
      if (productWrapper.querySelector(".second-product-price-compare")) {
        productWrapper.querySelector(
          ".second-product-price-compare"
        ).style.display = "none";
        productWrapper.querySelector(
          ".second-product-price-compare s"
        ).innerHTML = "";
      }
      productWrapper
        .querySelector(".second-product-price-final")
        .classList.remove("text-success");
      productWrapper.querySelector(".second-product-price-final").innerHTML =
        window.formatMoney(selectedVariant.price);
    }

    const url = new URL(window.location);
    url.searchParams.set("variant", selectedVariant.id);
    window.history.replaceState({}, "", url);
  }
};

// 'Buy it now' buttons
window.onClickBuyBtn = (btn) => {
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;
  const form = btn.closest("form");
  const variantId = form.querySelector('[name="id"]').value;
  const qty = Number(form.querySelector('input[name="quantity"]').value || 1);
  window.location.href = `/cart/${variantId}:${qty}`;
};

// Product Carousel - Sticky position on scroll (only desktop)
const productCarousel = document.querySelector("#product-carousel.sticky-top");
if (productCarousel) {
  const navbarHeight =
    document.querySelector("#shopify-section-navbar.sticky-top").clientHeight ||
    0;
  productCarousel.style.top = `${navbarHeight + 20}px`;
  productCarousel.style.zIndex = "1";
}

if (document.querySelector(".product-color-slider") !== null) {
  setProductColorOptionAvailability();
}

function getProductDataByProductOption(product) {
  // Create an empty object to store the new structure
  var newObject = [];

  // Loop through each option of the product
  product.options.forEach(function (option, optionIndex) {
    // Create a new object for the option
    var optionObject = {
      name: option,
      values: {},
    };

    // Loop through each value of the option
    product.variants.forEach(function (variant, variantIndex) {
      // Get the value of the current option for this variant
      var optionValue = variant.options[optionIndex];

      // Check if this value already exists in the optionObject
      if (optionObject.values.hasOwnProperty(optionValue)) {
        // If it does, push the variant to the existing array
        optionObject.values[optionValue].push(variant);
      } else {
        // If it doesn't, create a new array with the variant and add it to the values object
        optionObject.values[optionValue] = [variant];
      }
    });

    // Add the optionObject to the newObject with the option name as the key
    newObject.push(optionObject);
  });

  // Output the new object
  return newObject;
}

/**
 * Returns an array of the values of all checked input elements in the given array.
 *
 * @param {HTMLInputElement[]} inputs - An array of input elements.
 * @returns {string[]} An array of the values of all checked input elements in the given
 * @throws {TypeError} If the 'inputs' parameter is not an array-like object or is not defined.
 */
function getSelectedInputs(inputs) {
  if (!inputs || typeof inputs !== "object" || !inputs.length) {
    throw new TypeError(
      "The 'inputs' parameter must be an array-like object and cannot be undefined."
    );
  }

  var selectedInputs = [];
  for (var i = 0; i < inputs.length; i++) {
    if (inputs[i].checked) {
      selectedInputs.push(inputs[i].value);
    }
  }

  return selectedInputs;
}

function setProductColorOptionAvailability() {
  const checkedProductBubbleOption = document.querySelector(
    ".bubble-options input.product-option:checked"
  );
  const productColorSliderElement = document.querySelector(
    ".product-color-slider"
  );
  const sliderProductOptionLabels =
    productColorSliderElement.querySelectorAll("label");

  const variantOptions = {};
  product.variants.forEach((variant) => {
    const option0 = variant.options[0];
    const option1 = variant.options[1];
    if (!variantOptions[option0]) {
      variantOptions[option0] = {};
    }
    variantOptions[option0][option1] = variant.available;

    // if we have bubble options first, use them, otherwise go to next options available
    if (option0 && option1) {
      if (!variantOptions[option0]) {
        variantOptions[option0] = {};
      }
      variantOptions[option0][option1] = variant.available;
    } else if (option0) {
      if (!variantOptions[option0]) {
        variantOptions[option0] = {};
      }
      variantOptions[option0] = variant.available;
    }
  });

  sliderProductOptionLabels.forEach((label) => {
    let input = label.querySelector("input");

    // if we have bubble options first, use them, otherwise go to next options available
    if (
      checkedProductBubbleOption &&
      checkedProductBubbleOption.value &&
      input.value
    ) {
      let option0 = checkedProductBubbleOption.value;
      let option1 = input.value;

      if (variantOptions[option0] && variantOptions[option0][option1]) {
        input.disabled = false;
      } else {
        input.disabled = true;
      }
    } else if (input.value) {
      let option1 = input.value;

      if (variantOptions[option1]) {
        input.disabled = false;
      } else {
        input.disabled = true;
      }
    }
  });
}

function getSelectedOptions() {
  const inputs = document.getElementsByClassName("product-option");
  const selectedOptions = [];

  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i];

    // Check if the input is checked (for checkboxes and radio buttons)
    if (input.type === "checkbox" || input.type === "radio") {
      if (input.checked) {
        selectedOptions.push(input.value);
      }
    }
    // For other input types, like select or text, just push the value
    else {
      selectedOptions.push(input.value);
    }
  }

  return selectedOptions;
}

function findVariantByOptions(options) {
  const { variants } = product;

  for (let i = 0; i < variants.length; i++) {
    const variant = variants[i];
    const variantOptions = variant.options;

    if (options.every((option, index) => option === variantOptions[index])) {
      return variant;
    }
  }

  return null;
}

function getSelectedVariantPrice() {
  const selectedOptions = getSelectedOptions();
  const variant = findVariantByOptions(selectedOptions);

  if (variant) {
    return variant.price;
  }

  return null;
}

function hasParentWithClass(element, className) {
  let parent = element.parentElement;

  while (parent) {
    if (parent.classList.contains(className)) {
      return true;
    }
    parent = parent.parentElement;
  }

  return false;
}
